import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  accommodationContacts(filter) {
    return Api()
      .get('/accommodationcontacts', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  mesContacts(filter) {
    return Api()
      .get('/accommodationcontacts/mescontacts', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  accommodationContact(id) {
    return Api()
      .get('/accommodationcontact/' + id)
      .then((res) => this.formatRes(res.data));
  },
  contactTypes() {
    return Api()
      .get('/contacttypes')
      .then((res) => {
        return res.data;
      });
  },
  create(accommodationContact) {
    return Api()
      .post('/accommodationcontact', accommodationContact)
      .then((res) => this.formatRes(res.data));
  },
  createMultiple(accommodationContacts) {
    return Api()
      .post('/accommodationcontact/multiple', accommodationContacts)
      .then((res) => this.formatRes(res.data));
  },
  update(accommodationContact) {
    return Api()
      .put('/accommodationcontact/' + accommodationContact.id, accommodationContact)
      .then((res) => this.formatRes(res.data));
  },
  updateMultiple(accommodationContacts) {
    return Api()
      .put('/accommodationcontact/multiple2', accommodationContacts)
      .then((res) => this.formatRes(res.data));
  },
  delete(accommodationContact) {
    return Api()
      .delete('/accommodationcontact/' + accommodationContact.id)
      .then(() => accommodationContact);
  },
  formatRes(e) {
    return e;
  },
};
